import React, { useContext, useState, useEffect } from 'react';
import './AddCountryPopup.css';
import cn from "classnames";
import styles from './AddCountryPopup.module.sass';
import Modal from '@mui/material/Modal';
import Card from '../../../../components/Card';
import { GlobalState } from '../../../../App';
import TextInput from '../../../../components/TextInput';
import { getKeywordDocId, validate_if_not_empty } from '../../../../utils/extensions';
import Icon from '../../../../components/Icon';


const AddCountryPopup = () => {
  const { setIsClickedSave,
    countriesList, setCountriesList,
    activeEditCountry, setActiveEditCountry,
    setShowCountryPopup,
    showModalViewCountry, setShowModalViewCountry,
  } = useContext(GlobalState)

  const [countryTitle, setCountryTitle] = useState()
  const [countryTitleAr, setCountryTitleAr] = useState()

  const handleClose = () => {
    setActiveEditCountry()
    setShowModalViewCountry(false);
  }

  const TAG = "keyword popup"
  useEffect(() => {
    setIsClickedSave(false)
  }, [])

  useEffect(() => {
    if (activeEditCountry) {
      setCountryTitle(activeEditCountry?.title)
      setCountryTitleAr(activeEditCountry?.titleAr)
    }
  }, [activeEditCountry])

  const countryDetailsObj = {
    id: getKeywordDocId(),
    title: '',
    titleAr: '',
    dateCreated: '',
    dateEdited: ''
  }

  const createCountry = async () => {
    countryDetailsObj.title = countryTitle;
    countryDetailsObj.titleAr = countryTitleAr;
    // console.log(TAG, "after", countryDetailsObj)
    await setCountriesList((oldData) => [...oldData, countryDetailsObj])
    setIsClickedSave(true)
    setShowCountryPopup(false)
  }

  const updateCountry = async () => {
    for (let index = 0; index < countriesList.length; index++) {
      if (countriesList[index]?.id === activeEditCountry?.id) {
        countriesList[index].title = countryTitle
        countriesList[index].titleAr = countryTitleAr
        setActiveEditCountry()
        setIsClickedSave(true)
        setShowCountryPopup(false)
      }
    }
  }

  return (
    <Modal
      disableAutoFocus={true}
      open={showModalViewCountry}
      onClose={handleClose}
      className='dialog-wrapper'
      sx={{
        outline: '0 !important',
        border: 'none !important'
      }}
    >
      <Card
        className={cn(styles.card)}
        title="Add country"
        classTitle="title-green"
        classCardHead={styles.cardHead}
        head={
          <div style={{
            display: 'flex',
            gap: '12px'
          }}>

            <button
              onClick={() => {
                if (validate_if_not_empty(countryTitle, "countryTitlePopupErrId") && validate_if_not_empty(countryTitleAr, "countryTitleArPopupErrId")) {
                  activeEditCountry ? updateCountry() :
                    createCountry()
                }
              }}
              className={cn("button", styles.button)} >
              <span>Save</span>
            </button>
            <button
              onClick={() => {
                setActiveEditCountry('')
                setShowModalViewCountry(false)
              }}
              className={cn(styles.closeButton)} >
              <Icon name="close" fill="red" size="16" />
            </button>
          </div>

        }
      >
        <div className={styles.fieldContainer}>
          <TextInput
            className={styles.field}
            classInput={styles.fieldInput}
            label="title"
            name="popupCountryTitle"
            type="text"
            onChange={(e) => { setCountryTitle(e.target.value) }}
            value={countryTitle}
            required
          />
          <p className={styles.errField} id="countryTitlePopupErrId"></p>
        </div>

        <div className={styles.fieldContainer}>
          <TextInput
            className={styles.field}
            classInput={styles.fieldInput}
            label="TitleAr"
            name="popupCountryTitleAr"
            type="text"
            onChange={(e) => { setCountryTitleAr(e.target.value) }}
            value={countryTitleAr}
            required
          />
          <p className={styles.errField} id="countryTitleArPopupErrId"></p>
        </div>
      </Card>

    </Modal>

  )
}

export default AddCountryPopup